/*** IMPORTS FROM imports-loader ***/
var define = false;

import cb from './_cb.js';
import each from './each.js';

// An internal function used for aggregate "group by" operations.
export default function group(behavior, partition) {
  return function(obj, iteratee, context) {
    var result = partition ? [[], []] : {};
    iteratee = cb(iteratee, context);
    each(obj, function(value, index) {
      var key = iteratee(value, index, obj);
      behavior(result, value, key);
    });
    return result;
  };
}




//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/_group.js
// module id = 25
// module chunks = 0